module.exports = __webpack_public_path__ + "img/Clear.3080c218.png";